import {firmsPlural} from 'stringsPlural';

export default {
    found: {
        zero: 'Found',
        one: 'Found',
        few: 'Found',
        many: 'Found',
        other: 'Found'
    },
    companies: firmsPlural.en,
    noCompanies: 'Companies not found',
    moreThan: 'more than',
    direction: 'in direction {{from}}\u00A0— {{to}} in\u00A0{{period}}',
};
